import type { StepContentConfig } from '@workspace/core-ts/utils';

const vehiculeContent: StepContentConfig = {
    mainTitle: {
        site: 'Votre vélo',
        courtier: 'Son vélo',
    },

    recueilBesoinTitle: {
        site: 'Souhaitez-vous utiliser le Recueil du Besoin ?',
        courtier: 'Souhaitez-vous utiliser le Recueil du Besoin ?',
    },

    recueilBesoinInfo: {
        site: `Le Saviez-vous ?
Vous avez la possibilité d'activer le Recueil du Besoin pour obtenir une Fiche Conseil.

Si vous souhaitez bénéficier de ce service, vous avez la possibilité de remplir toutes les informations nécessaires à la personnalisation de la Fiche Conseil dans votre espace, rubrique "Mon profil".

Si vous préférez utiliser votre document, vous pouvez poursuivre la souscription.`,
    },

    motifAvenantTitle: {
        site: "Motif de l'avenant ?",
        courtier: "Motif de l'avenant ?",
    },

    typeVeloTitle: {
        site: 'Quel est <strong>le type</strong> de votre <strong>vélo</strong> ?',
        courtier: 'Quel est <strong>le type</strong> de <strong>vélo</strong> ?',
    },

    marqueTitle: {
        site: 'Quelle est <strong>la marque</strong> de votre <strong>vélo</strong> ?',
        courtier: 'Quelle est <strong>la marque</strong> du <strong>vélo</strong> ?',
    },

    valeurTitle: {
        site: "Quelle est <strong>la valeur d'achat</strong> de votre <strong>vélo</strong> ?",
        courtier: "Quelle est <strong>la valeur d'achat</strong> du <strong>vélo</strong> ?",
    },

    dateAchatTitle: {
        site: (
            <p>
                Quelle est <strong>la date d'achat</strong> de votre <strong>vélo</strong> ?
            </p>
        ),
        courtier: (
            <p>
                Quelle est <strong>la date d'achat</strong> du <strong>vélo</strong> ?
            </p>
        ),
    },

    declarationPuissanceTitle: {
        site: (
            <p>
                Je déclare que mon <strong>vélo</strong> est d'une puissance inférieure ou égale à 250 W et que sa vitesse est limitée à 25 km/h
            </p>
        ),
        courtier: (
            <p>
                Votre client déclare que son <strong>vélo</strong> est d'une puissance inférieure ou égale à 250 W et que sa vitesse est limitée à 25 km/h
            </p>
        ),
    },

    declarationUsageTitle: {
        site: "Je déclare que mon vélo n'est pas destiné à un usage professionnel lié à une activité de restauration, de livraison ou de transport à titre onéreux",
        courtier:
            "Votre client déclare que son vélo n'est pas destiné à un usage professionnel lié à une activité de restauration, de livraison ou de transport à titre onéreux",
    },

    bulleAideValeur: {
        site: (
            <>
                <p>
                    Nous assurons tous les vélos achetés neuf ou d'occasion chez un professionnel avec une <b>facture d'achat de moins de 6 mois</b>.
                </p>
                <p>
                    La <b>valeur d'achat</b> correspond au prix de votre vélo <b>incluant ses accessoires achetés en même temps</b>.
                </p>
                <p>La valeur du vélo (avec les accessoires) doit être comprise entre 800€ et 6000€ TTC.</p>
            </>
        ),
        courtier: (
            <>
                <p>
                    Nous assurons tous les vélos achetés neuf ou d'occasion chez un professionnel avec une <b>facture d'achat de moins de 6 mois</b>.
                </p>
                <p>
                    La <b>valeur d'achat</b> correspond au prix du vélo de votre client <b>incluant ses accessoires achetés en même temps</b>.
                </p>
                <p>La valeur du vélo (avec les accessoires) doit être comprise entre 800€ et 6000€ TTC.</p>
            </>
        ),
    },
    bulleAideMarque: {
        site: (
            <>
                <p>
                    Renseignez la marque de votre vélo indiquée sur la facture d'achat.
                    <br />
                    Cette marque apparaîtra sur la proposition d'assurance et sur votre futur contrat d'assurance.
                </p>
            </>
        ),
        courtier: (
            <>
                <p>
                    Renseignez la marque du vélo de votre client indiquée sur la facture d'achat.
                    <br />
                    Cette marque apparaîtra sur la proposition d'assurance et sur le futur contrat d'assurance.
                </p>
            </>
        ),
    },
    bulleAideAchat: {
        site: (
            <>
                <p>
                    Renseignez la <b>date d'achat de votre vélo</b> indiquée sur la facture délivrée par le professionnel.
                </p>
                <p>
                    Nous assurons tous les vélos achetés neuf ou d'occasion chez un professionnel avec une <b>facture d'achat de moins de 6 mois</b>.
                </p>
            </>
        ),
        courtier: (
            <>
                <p>
                    Renseignez la <b>date d'achat du vélo</b> de votre client indiquée sur la facture délivrée par le professionnel.
                </p>
                <p>
                    Nous assurons tous les vélos achetés neuf ou d'occasion chez un professionnel avec une <b>facture d'achat de moins de 6 mois</b>.
                </p>
            </>
        ),
    },
    bulleAideTypeVelo: {
        site: (
            <>
                <p>
                    <b>Vélo classique :</b> Un vélo sans assistance électrique, idéal pour les trajets quotidiens ou les balades.
                </p>
                <p>
                    <b>Vélo à assistance électrique (VAE)</b> : Un vélo équipé d’un moteur électrique qui vous aide au pédalage pour aller plus loin, plus
                    facilement.
                </p>
                <p>
                    <b>Vélo cargo (classique ou VAE)</b> : Un vélo conçu pour transporter de lourdes charges ou plusieurs enfants, disponible en version
                    classique ou électrique.
                </p>
            </>
        ),
        courtier: (
            <>
                <p>
                    <b>Vélo classique :</b> Un vélo sans assistance électrique, idéal pour les trajets quotidiens ou les balades.
                </p>
                <p>
                    <b>Vélo à assistance électrique (VAE)</b> : Un vélo équipé d’un moteur électrique qui vous aide au pédalage pour aller plus loin, plus
                    facilement.
                </p>
                <p>
                    <b>Vélo cargo (classique ou VAE)</b> : Un vélo conçu pour transporter de lourdes charges ou plusieurs enfants, disponible en version
                    classique ou électrique.
                </p>
            </>
        ),
    },
};

export default vehiculeContent;
